module.exports = __webpack_public_path__ + "static/media/ok-computer.458c44dd.jpg";